/*
 * @Descripttion: 开票申请详情页state
 * @Author: 曹博
 * @Date: 2023-11-27 15:14:52
 * @LastEditors: 曹博
 * @LastEditTime: 2023-12-08 08:50:22
 */
import { OrderDteailRes, ProductList } from '../../api/orderManage'
import { ActionType, CustomAction } from '../../global'
import { fileFile } from '../../modules/uploadfiles/hooks'
import { InvoiceType } from '../invoiceApplication/reducer'

export interface RouteParams {
  orderId: string // 订单 id
  applicationNumber: string // 开票申请单号;
}

export interface OrderInvoiceParams {
  address: string // 地址
  bankAccount: string // 银行账号
  bankName: string // 开户银行
  content?: string // 票面描述
  fileIdList?: string[]
  mobile: string // 电话
  orderId: string // 电商供应商订单 id
  orderInvoiceEnums: string // 发票类型
  receiveAddress: string // 收件人地址
  province?: string // 省
  city?: string // 市
  provinceCode?: string // 省编码
  cityCode?: string // 市编码
  receiveMan: string // 收件人
  receiveMobile: string // 收件人联系电话
  remark?: string // 其它备注
  taxNumber: string // 税号
  title: string // 发票抬头
}

export interface InvoicingInfo extends OrderInvoiceParams {
  fileList: fileFile[]
  id: string // 开票信息id
  mail: string
}

export interface State {
  routeParams: RouteParams
  invoiceInfoData: any[] // 发票信息表格数据
  invoicingInfo?: InvoicingInfo // 开票信息&其他信息
  orderData: OrderDteailRes[]
  materialData: ProductList[]
  invoiceType?: InvoiceType // 开票状态
  isPreviewModalVisible: boolean
  previewFileUrl: string
}

export const initialState: State = {
  routeParams: {
    orderId: '',
    applicationNumber: '',
  },
  invoiceInfoData: [], // 发票信息表格数据
  orderData: [],
  materialData: [],
  isPreviewModalVisible: false,
  previewFileUrl: '',
}

type Action = ActionType<State>

export default function reducer(
  state: State,
  action: CustomAction<Action>,
): State {
  let newstate = { ...state }
  switch (action.type) {
    case 'reloadStateAction':
      newstate = action.payload
      return newstate
    case 'setRouteParamsAction':
      newstate.routeParams = action.payload
      return newstate
    case 'setInvoiceInfoDataAction':
      newstate.invoiceInfoData = action.payload
      return newstate
    case 'setInvoicingInfoAction':
      newstate.invoicingInfo = action.payload
      return newstate
    case 'setOrderDataAction':
      newstate.orderData = action.payload
      return newstate
    case 'setMaterialDataAction':
      newstate.materialData = action.payload
      return newstate
    case 'setInvoiceTypeAction':
      newstate.invoiceType = action.payload
      return newstate
    case 'setIsPreviewModalVisibleAction':
      newstate.isPreviewModalVisible = action.payload
      return newstate
    case 'setPreviewFileUrlAction':
      newstate.previewFileUrl = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}

export const reloadStateAction = (val: State): CustomAction<Action> => ({
  type: 'reloadStateAction',
  payload: val,
})

// 保存路由参数
export const setRouteParamsAction = (
  val: RouteParams,
): CustomAction<Action> => ({
  type: 'setRouteParamsAction',
  payload: val,
})

// 发票信息表格数据
export const setInvoiceInfoDataAction = (val: any[]): CustomAction<Action> => ({
  type: 'setInvoiceInfoDataAction',
  payload: val,
})

// 开票信息
export const setInvoicingInfoAction = (val: any): CustomAction<Action> => ({
  type: 'setInvoicingInfoAction',
  payload: val,
})

// 订单信息
export const setOrderDataAction = (val: any): CustomAction<Action> => ({
  type: 'setOrderDataAction',
  payload: val,
})

// 物料明细
export const setMaterialDataAction = (val: any[]): CustomAction<Action> => ({
  type: 'setMaterialDataAction',
  payload: val,
})

// 开票状态
export const setInvoiceTypeAction = (val: string): CustomAction<Action> => ({
  type: 'setInvoiceTypeAction',
  payload: val,
})

// 预览弹窗
export const setIsPreviewModalVisibleAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setIsPreviewModalVisibleAction',
  payload: val,
})

// 预览文件url
export const setPreviewFileUrlAction = (val: string): CustomAction<Action> => ({
  type: 'setPreviewFileUrlAction',
  payload: val,
})
/*
 * @Descripttion: 开票申请详情页state
 * @Author: 曹博
 * @Date: 2023-11-27 15:14:52
 * @LastEditors: 曹博
 * @LastEditTime: 2023-12-08 08:50:22
 */
import { OrderDteailRes, ProductList } from '../../api/orderManage'
import { ActionType, CustomAction } from '../../global'
import { fileFile } from '../../modules/uploadfiles/hooks'
import { InvoiceType } from '../invoiceApplication/reducer'

export interface RouteParams {
  orderId: string // 订单 id
  applicationNumber: string // 开票申请单号;
}

export interface OrderInvoiceParams {
  address: string // 地址
  bankAccount: string // 银行账号
  bankName: string // 开户银行
  content?: string // 票面描述
  fileIdList?: string[]
  mobile: string // 电话
  orderId: string // 电商供应商订单 id
  orderInvoiceEnums: string // 发票类型
  receiveAddress: string // 收件人地址
  province?: string // 省
  city?: string // 市
  provinceCode?: string // 省编码
  cityCode?: string // 市编码
  receiveMan: string // 收件人
  receiveMobile: string // 收件人联系电话
  remark?: string // 其它备注
  taxNumber: string // 税号
  title: string // 发票抬头
}

export interface InvoicingInfo extends OrderInvoiceParams {
  fileList: fileFile[]
  id: string // 开票信息id
  mail: string
}

export interface State {
  routeParams: RouteParams
  invoiceInfoData: any[] // 发票信息表格数据
  invoicingInfo?: InvoicingInfo // 开票信息&其他信息
  orderData: OrderDteailRes[]
  materialData: ProductList[]
  invoiceType?: InvoiceType // 开票状态
  isPreviewModalVisible: boolean
  previewFileUrl: string
}

export const initialState: State = {
  routeParams: {
    orderId: '',
    applicationNumber: '',
  },
  invoiceInfoData: [], // 发票信息表格数据
  orderData: [],
  materialData: [],
  isPreviewModalVisible: false,
  previewFileUrl: '',
}

type Action = ActionType<State>

export default function reducer(
  state: State,
  action: CustomAction<Action>,
): State {
  let newstate = { ...state }
  switch (action.type) {
    case 'reloadStateAction':
      newstate = action.payload
      return newstate
    case 'setRouteParamsAction':
      newstate.routeParams = action.payload
      return newstate
    case 'setInvoiceInfoDataAction':
      newstate.invoiceInfoData = action.payload
      return newstate
    case 'setInvoicingInfoAction':
      newstate.invoicingInfo = action.payload
      return newstate
    case 'setOrderDataAction':
      newstate.orderData = action.payload
      return newstate
    case 'setMaterialDataAction':
      newstate.materialData = action.payload
      return newstate
    case 'setInvoiceTypeAction':
      newstate.invoiceType = action.payload
      return newstate
    case 'setIsPreviewModalVisibleAction':
      newstate.isPreviewModalVisible = action.payload
      return newstate
    case 'setPreviewFileUrlAction':
      newstate.previewFileUrl = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}

export const reloadStateAction = (val: State): CustomAction<Action> => ({
  type: 'reloadStateAction',
  payload: val,
})

// 保存路由参数
export const setRouteParamsAction = (
  val: RouteParams,
): CustomAction<Action> => ({
  type: 'setRouteParamsAction',
  payload: val,
})

// 发票信息表格数据
export const setInvoiceInfoDataAction = (val: any[]): CustomAction<Action> => ({
  type: 'setInvoiceInfoDataAction',
  payload: val,
})

// 开票信息
export const setInvoicingInfoAction = (val: any): CustomAction<Action> => ({
  type: 'setInvoicingInfoAction',
  payload: val,
})

// 订单信息
export const setOrderDataAction = (val: any): CustomAction<Action> => ({
  type: 'setOrderDataAction',
  payload: val,
})

// 物料明细
export const setMaterialDataAction = (val: any[]): CustomAction<Action> => ({
  type: 'setMaterialDataAction',
  payload: val,
})

// 开票状态
export const setInvoiceTypeAction = (val: string): CustomAction<Action> => ({
  type: 'setInvoiceTypeAction',
  payload: val,
})

// 预览弹窗
export const setIsPreviewModalVisibleAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setIsPreviewModalVisibleAction',
  payload: val,
})

// 预览文件url
export const setPreviewFileUrlAction = (val: string): CustomAction<Action> => ({
  type: 'setPreviewFileUrlAction',
  payload: val,
})
